import {useSelector} from "react-redux";
import {Navigate, NavLink} from "react-router-dom";
import React from "react";
import s from './Account.module.css';




const AccountMain = () => {
    const isAuth = useSelector(state => state.authUser.isAuth);
    const email = useSelector(state => state.authUser.email);
    const userInfo = useSelector(state => state.setUserData);


    return (<>
            {isAuth ? <div className={s.accountProfile}>
                <h3>Личный кабинет</h3>
                <div>
                    <h5>Информация</h5>
                    <ul>
                        <li><strong>Почта:</strong>{email}</li>
                        <li><strong>ФИО:</strong>{`${userInfo.name} ${userInfo.surname}`}</li>
                        <li><strong>Номер телефона:</strong>{userInfo.phone}</li>
                        <li><strong>Страна:</strong>{userInfo.country}</li>
                    </ul>
                </div>
                <div>
                    <h5>Моя учетная запись</h5>
                    <ul>
                        <li><NavLink to="edit-profile">Изменить контактную информацию</NavLink></li>
                        <li><NavLink to="change-password">Изменить свой пароль</NavLink></li>
                        <li><NavLink to="edit-adress">Изменить адрес</NavLink></li>
                    </ul>
                </div>
                <div>
                    <h5>Мои заказы</h5>
                    <ul>
                        <li><NavLink to="">История заказов</NavLink></li>
                        <li><NavLink to="">Избранные</NavLink></li>
                    </ul>
                </div>
            </div> : <Navigate to="login"/>}

        </>
    )
}

export default AccountMain;